export default class formConfig {
  // 工程类别详情
  static configList() {
    return [
      {
        title: "工程类别详情",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "类别名称：",
            type: "input",
            value: "categoryName",
            placeholder: "请输入",
            maxlength: 200,
            rule: {
              required: true,
              message: "请填写类别名称",
              trigger: "blur"
            }
          },
          {
            label: "上级工程类别：",
            type: "select",
            value: "parentId",
            placeholder: "请输入",
            queryParams: {
              url: "/engineeringCategory/EngineeringCategoryCombobox",
              parentId: "0"
            },
            rule: {
              required: true,
              message: "请选择上级工程类别",
              trigger: "blur"
            }
          },
        ]
      },
    ];
  }
}
